import React from 'react';
import { Sticky, Rail } from 'semantic-ui-react';
import Context from '../Utilities';

const { Fragment } = window.wp.element;

function Quotes() {
    // missing forEach on NodeList for IE11
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    function filterQuotes(e) {
        const quoteType = e.currentTarget.id;
        const selectedType = document.querySelector(`#allQuotes .${quoteType}`);
        const selectedQuotes = document.querySelectorAll(
            `#allQuotes .${quoteType}`,
        );
        const activeButton = e.currentTarget;
        const viewAllButton = document.getElementById('viewAllQuotes');

        [...activeButton.parentElement.children].forEach(sib =>
            sib.classList.remove('active'));
        activeButton.classList.add('active');
        [...selectedType.parentElement.children].forEach(sib =>
            sib.classList.add('inactive'));

        selectedQuotes.forEach(quote => quote.classList.remove('inactive'));

        viewAllButton.classList.add('active');
    }
    function viewAllQuotes(e) {
        const selectedQuotes = document.querySelectorAll(
            `#allQuotes .quoteBox`,
        );
        const activeButton = document.querySelector(`#quoteButtons .active`);
        activeButton.classList.remove('active');

        selectedQuotes.forEach(quote => quote.classList.remove('inactive'));
        e.currentTarget.classList.remove('active');
    }
    return (
        <Context.Consumer>
            {({ data }) => {
                const quoteBoxes = data.map(quote => (
                    <div className={`quoteBox ${quote.type}`}>
                        <p>
                            {quote.quote}&rdquo; – {quote.gender}, {quote.age}
                        </p>
                    </div>
                ));

                return (
                    <Fragment>
                        <div id="quotes">
                            <div className="stickyFooter">
                                <p id="filter">Filter Responses</p>
                                <div id="quoteButtons">
                                    <button
                                        type="button"
                                        className="ui button medium DisapproveShare"
                                        id="DisapproveShare"
                                        onClick={e => filterQuotes(e)}
                                    >
                                        Disapprove, would share
                                    </button>
                                    <button
                                        type="button"
                                        className="ui button medium ApproveShare"
                                        id="ApproveShare"
                                        onClick={e => filterQuotes(e)}
                                    >
                                        Approve, would share
                                    </button>
                                    <button
                                        type="button"
                                        className="ui button medium ApproveNotShare"
                                        id="ApproveNotShare"
                                        onClick={e => filterQuotes(e)}
                                    >
                                        Approve, would not share
                                    </button>
                                    <button
                                        type="button"
                                        className="ui button medium DisapproveNotShare"
                                        id="DisapproveNotShare"
                                        onClick={e => filterQuotes(e)}
                                    >
                                        Disapprove, would not share
                                    </button>
                                </div>
                                <button
                                    type="button"
                                    className="ui button medium"
                                    id="viewAllQuotes"
                                    onClick={e => viewAllQuotes(e)}
                                >
                                    View all
                                </button>
                            </div>
                            <div id="allQuotes">{quoteBoxes}</div>
                            <p className="source">
                                Methodology:{' '}
                                <a
                                    href="https://www.people-press.org/2019/06/19/political-discourse-methodology/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Survey of U.S. adults conducted April 29-May
                                    13, 2019
                                </a>
                                . Age and gender of respondents are
                                self-reported. Open-ended question.
                            </p>
                            <p className="source">Credit: Sara Atske</p>
                        </div>
                    </Fragment>
                );
            }}
        </Context.Consumer>
    );
}

export default Quotes;
